// extracted by mini-css-extract-plugin
export var container = "_9s-1";
export var cornerButtonContainer = "_9s-5";
export var disabled = "_9s-2";
export var fileContainer = "_9s-4";
export var hiddenInput = "_9s-3";
export var widthContainer = "_9s-0";